import { render, staticRenderFns } from "./Justifications.vue?vue&type=template&id=5a325a64"
import script from "./Justifications.vue?vue&type=script&lang=js"
export * from "./Justifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports